import { api } from '@/helpers/apiClient'
import logger from '@/helpers/logger'
import {
  outboundEmailDetailDtoSchema,
  outboundEmailListDtoSchema,
  type OutboundEmailDetailDto,
  type OutboundEmailListDto,
} from '@lib/dto/outbound-email.dto'
import type { OutboundEmailCategory } from '@lib/enums/outbound-email.enum'

const path = (loanId: string) => `/loans/${loanId}/outbound-emails`

class OutboundEmailService {
  async list(
    loanId: string,
    category?: OutboundEmailCategory,
  ): Promise<OutboundEmailListDto> {
    try {
      const query =
        category != null ? `?category=${encodeURIComponent(category)}` : ''
      return await api.get(`${path(loanId)}${query}`, outboundEmailListDtoSchema)
    } catch (error) {
      logger.failure('Failed to list outbound emails', error, {
        loanId,
        category,
      })
      throw error
    }
  }

  async get(loanId: string, emailId: string): Promise<OutboundEmailDetailDto> {
    try {
      return await api.get(
        `${path(loanId)}/${emailId}`,
        outboundEmailDetailDtoSchema,
      )
    } catch (error) {
      logger.failure('Failed to load outbound email', error, {
        loanId,
        emailId,
      })
      throw error
    }
  }

  async downloadAttachment(
    loanId: string,
    emailId: string,
    attachmentId: string,
  ): Promise<Blob> {
    try {
      return await api.getBlob(
        `${path(loanId)}/${emailId}/attachments/${attachmentId}`,
      )
    } catch (error) {
      logger.failure('Failed to download email attachment', error, {
        loanId,
        emailId,
        attachmentId,
      })
      throw error
    }
  }
}

export const outboundEmailService = new OutboundEmailService()
